import React from "react";
import JobCarousel from "../Cards/Job-card";
import Link from "next/link";

const JobSection = () => {
  return (
    <div className="container">
      <div className="row mb--10 mt--20">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="subtitle bg-secondary-opacity">Explore Jobs</span>
            <h2 className="title">
              Top Openings
              <br />
              That Everyone’s Talking About 🔥
            </h2>
          </div>
        </div>
      </div>
      <div className="row mt--80">
        <JobCarousel />
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="load-more-btn mt--30 text-center">
            <Link
              href="/jobs"
              className="rbt-btn btn-gradient btn-lg hover-icon-reverse"
            >
              <span className="icon-reverse-wrapper">
                <span className="btn-text">Load More Jobs</span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobSection;
